import React from 'react'
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { FaRegLightbulb } from 'react-icons/fa';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';

const Testimonials = () => {
    const data=useStaticQuery(graphql`
    query{
        allFile(filter: {ext: {regex: "/(jpg)|(png)|(jpeg)/"}, 
        name: {in:["Ganesha","Damru"]}}) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
     }
    `)
  return (
    <TestmonialContainer>
       <TopLine>
           Testimonials
       </TopLine>
       <Description>
           Descritpion here about site
       </Description>
        <ContentWrapper>
            <Coulamone>
                <Testimonial>
                    <IoMdCheckmarkCircleOutline
                     css={`
                         color:lightgreen;
                         font-size:2rem;
                         margin-bottom:1rem;
                     `}
                    />
                   <h3>Lorem Ipsum</h3>
                   <p>Reference site about Lorem Ipsum,
                    giving information on its origins,
                    as well as a random Lipsum generator</p>
                </Testimonial>
                <Testimonial>
                    <FaRegLightbulb
                     css={`
                     color:brown;
                     font-size:2rem;
                     margin-bottom:1rem;
                 `}
                    />
                   <h3>Lorem Ipsum</h3>
                   <p>Reference site about Lorem Ipsum,
                    giving information on its origins,
                    as well as a random Lipsum generator</p>
                </Testimonial>
            </Coulamone>
            <Coulamtwo>
               {
                 data.allFile.edges.map((item,index)=>{
                  return  <Images
                      key={index} 
                      fluid={item.node.childImageSharp.fluid}
                    />
                 })
               }
            </Coulamtwo>
        </ContentWrapper>
    </TestmonialContainer>
  )
}

export default Testimonials;

const TestmonialContainer=styled.div`
   width:100%;
   background:#fcfcfc;
   color: #000;
   padding:5rem calc((100vw - 1300px)/2);
   height:100%;
`;
const TopLine=styled.div`
  color: #077bf1;
  font-size:1rem;
  padding-left:2rem;
  margin-bottom:0.75rem;
`;
const Description=styled.div`
  text-align:start;
  padding-left:2rem;
  margin-bottom:4rem;
  font-size:clamp(1.5rem,5vw,2rem);
  font-weight:bold;
`;
const ContentWrapper=styled.div`
    display:grid;
    grid-template-columns:1fr 1fr;
    padding:0 2rem;
    @media screen and (max-width:768px){
        grid-template-columns:1fr;
    }
`;
const Coulamone=styled.div`
    display:grid;
    grid-template-rows:1fr 1fr;
`;
const Testimonial=styled.div`
  padding-top:1rem;
  padding-right:2rem;
h3 {
    margin-bottom:1rem;
    font-size:1.5rem;
    font-style:italic;
}
p{
  color: #3b3b3b;
}
`
;
const Coulamtwo=styled.div`
    display:grid;
    grid-template-columns:1fr 1fr;
    padding-top:2rem;
    grid-gap:30px;
    @media screen and(max-width:500px){
        grid-template-columns:1fr;
    }
`;
const Images=styled(Img)`
   border-radius:10px;
   height: 100%;
`
